import React from 'react';
import styled from 'styled-components';
import Rating from '@mui/material/Rating';
import Image from 'next/image';
import useTranslation from 'next-translate/useTranslation';
import { noDesktop, useIsDesktop, useIsMobile } from '../../style/constants';
import { Col, Container, Row } from '../../VuexyDesign/atoms/_index';
import PricingCardButtonUpdated from './PricingCardButtonUpdated';
import { Plan } from './index';
import DistributionButton from '../Distribution/DistributionButton';

interface TestimonialProps {
  title: string;
  subtitle?: string;
  plan?: Plan[];
}

function Testimonial({ title, subtitle, plan }: TestimonialProps) {
  const { t } = useTranslation('pricing');
  const isMobile = useIsMobile();
  const isDesktop = useIsDesktop();
  return (
    <ContainerTestimonial
      className={`${
        plan ? 'div-gradient-background pt-3' : 'bg-light'
      } pb-3  user-select-none`}
    >
      <Container
        fluid
        className={`mx-auto text-center ${!isDesktop ? 'w-100' : 'w-75'}`}
      >
        <h2 className="custom-heading-font-2">{title}</h2>
        <br />
        {subtitle ? (
          <p className="custom-font-text-regular-normal paragraph-color">
            {subtitle}
          </p>
        ) : (
          <></>
        )}
      </Container>

      <div className={`mb-5 mx-auto mt-3 ${isMobile ? 'w-100' : 'w-75'}`}>
        <div>
          <Row className=" text-left TestimonialRow">
            {testimonialUsers.map((item) => (
              <Col
                md={6}
                xl={4}
                xs={12}
                className="mt-1"
                key={`trusted-label-${item.name}`}
              >
                <TestMonialCard
                  imgUrl={item.imgUrl}
                  name={item.name}
                  description={item.description}
                  job={item.job}
                  key={`trusted-item-${item.id}`}
                />
              </Col>
            ))}
          </Row>
        </div>
        <div className="mt-3 justify-content-center d-flex">
          <h3 className="custom-heading-font-3">
            {t('pricing:readyToCreateYour')}
          </h3>
        </div>
        <div className="mt-2 justify-content-center d-flex">
          {plan ? (
            <>
              <PricingCardButtonUpdated type="GET_STARTED" plan={plan[0]} />
            </>
          ) : (
            <>
              <DistributionButton
                type="GRADIENT_FILLED"
                text={t('pricing:scheduleRelease') as string}
              />
            </>
          )}
        </div>
      </div>
    </ContainerTestimonial>
  );
}

function TestMonialCard({ imgUrl, name, description, job }: TrustedProps) {
  const { t } = useTranslation('organisms');
  return (
    <div className="d-flex flex-column border-light p-1 br-10 text-left bg-white h-100">
      <Rating
        name="half-rating-read"
        defaultValue={5}
        precision={0.1}
        readOnly
      />
      <span className="custom-font-text-small-normal my-1">
        {t(description)}
      </span>
      <div className="d-flex">
        <UserImage
          height={30}
          width={30}
          alt="testimonial users"
          src={imgUrl}
        />
        <div className="d-flex flex-column ml-1">
          <span className="custom-font-text-small-medium">{name}</span>
          <span className="custom-font-text-small-normal ">{t(job)}</span>
        </div>
      </div>
    </div>
  );
}

const UserImage = styled(Image)<{ size?: number; border?: boolean }>`
  border-radius: 50%;
  border: ${(p) => (p.border ? '3px solid white' : 'none')};
`;

interface TrustedProps {
  imgUrl: string;
  name: string;
  description: string;
  job: string;
}

const testimonialUsers: {
  id: number;
  imgUrl: string;
  logoUrl: string;
  name: string;
  description: string;
  job: string;
}[] = [
  {
    id: 1,
    imgUrl: '/static/images/distribution-landing/user-profile1.webp',
    logoUrl: '/static/images/distribution-landing/user-profile1.webp',
    name: 'Jameson Andrews',
    description: 'organisms:trustedArtists.jamesonAndrews',
    job: 'organisms:trustedArtists.artistOnVirpp',
  },
  {
    id: 2,
    imgUrl: '/static/images/distribution-landing/user-profile2.webp',
    logoUrl: '/static/images/distribution-landing/user-profile2.webp',
    name: 'Lamas',
    description: 'organisms:trustedArtists.lamas',
    job: 'organisms:trustedArtists.collabViaVirpp',
  },
  {
    id: 3,
    imgUrl: '/static/images/distribution-landing/user-profile3.webp',
    logoUrl: '/static/images/distribution-landing/user-profile3.webp',
    name: 'DJ Xquizit',
    description: 'organisms:trustedArtists.djXquizit',
    job: 'organisms:trustedArtists.artistOnVirpp',
  },

  {
    id: 4,
    imgUrl: '/static/images/home/johnSmith.webp',
    logoUrl: '/static/images/home/johnSmith.webp',
    name: 'John Smith',
    description: 'organisms:trustedArtists.johnSmith',
    job: 'organisms:trustedArtists.singerSongwriter',
  },
  {
    id: 5,
    imgUrl: '/static/images/home/sarahJohnson.webp',
    logoUrl: '/static/images/home/sarahJohnson.webp',
    name: 'Sara Johnson',
    description: 'organisms:trustedArtists.sarahJohnson',
    job: 'organisms:trustedArtists.electronicMusicProducer',
  },
  {
    id: 6,
    imgUrl: '/static/images/home/davidLee.webp',
    logoUrl: '/static/images/home/davidLee.webp',
    name: 'David Lee',
    description: 'organisms:trustedArtists.davidLee',
    job: 'organisms:trustedArtists.hiphopArtist',
  },
];
export default Testimonial;
const ContainerTestimonial = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: auto;
  padding: auto;
  width: 100%;

  .TestimonialRow {
    @media ${noDesktop} {
      margin: 0;
      padding: 0;
    }
  }
`;
